// Why a coach change waits for Accept when it would otherwise have applied:
// the backend's loop guard held it (app/thread/cards.py `held`, from the
// change's `blocked:budget` / `blocked:cooldown` evidence). The card says so
// in plain words (planning review gap 9, 2026-10-24). The same words are on
// mobile (lib/v2/held.ts).
export const HELD_TEXT = {
  budget: "I've changed a lot today, so this one waits for your OK.",
  cooldown: 'I changed this session recently, so this one waits for your OK.',
};

/** The line for an open proposal the coach held back, or null. */
export function heldText(item) {
  if (item?.type !== 'proposal' || item.state !== 'active') return null;
  const b = item.body || {};
  if (typeof b.held_text === 'string' && b.held_text.trim()) return b.held_text.trim();
  return HELD_TEXT[b.held] || null;
}
